import React, { useState } from 'react';

import { NewMessage } from '@/components/NewMessage';
import { AsaphButton } from '@/components/shared/Button/AsaphButton';
import { useAnalyticsEvent } from '@/providers/AnalyticsProvider';
import { useSubscription } from '@/providers/SubscriptionProvider';

import styles from './ChatHistoryGate.module.scss';

type Props = {
	isGated: boolean;
	isAdmin: boolean;
	children: React.ReactNode;
};

export const ChatHistoryGate: React.FC<Props> = ({
	isGated,
	isAdmin,
	children,
}) => {
	const [messageOpen, setMessageOpen] = useState(false);
	const { setPaidModalOpen } = useSubscription();
	const fireUpgradeClick = useAnalyticsEvent('Upgrade_Gate_Upgrade_Clicked');
	const fireMessageAdminEvent = useAnalyticsEvent('Chat_History_Gate_Message_Admin');

	const handleUpgrade = () => {
		fireUpgradeClick({ gate: 'chat_history' });
		setPaidModalOpen(true);
	};

	return (
		<div className={styles.root}>
			<div className={isGated ? styles.blurred : undefined}>
				{children}
			</div>
			{isGated && (
				<div className={styles.overlay}>
					<div className={styles['sticky-anchor']}>
						<div className={styles.card}>
							<div className={styles.header}>
								<span className={styles.title}>
									Chat history
								</span>
							</div>
							<div className={styles.form}>
								{isAdmin
									? 'Your team is limited to the last 30 days of chat history. Upgrade to the Leader plan for unlimited history.'
									: 'You are limited to the last 30 days of chat history. Message an admin and request an upgrade to a paid plan to go unlimited.'}
							</div>
							<div className={styles.action}>
								{isAdmin ? (
									<AsaphButton
										color="green"
										label="Upgrade to Leader"
										fullWidth
										onClick={handleUpgrade}
									/>
								) : (
									<AsaphButton
										color="blue"
										label="Message Admin"
										fullWidth
										onClick={() => {
											fireMessageAdminEvent();
											setMessageOpen(true);
										}}
									/>
								)}
							</div>
						</div>
					</div>
				</div>
			)}
			<NewMessage
				open={messageOpen}
				handleClose={() => setMessageOpen(false)}
			/>
		</div>
	);
};
